import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PwaInstallService {
  private deferredPrompt: any;
  private installPromptVisible = new BehaviorSubject<boolean>(false);
  installPrompt$ = this.installPromptVisible.asObservable();

  private isLoading = new BehaviorSubject<boolean>(false); // Controla el estado de carga
  loading$ = this.isLoading.asObservable();

  constructor() {
    window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.installPromptVisible.next(true); // Muestra el botón de instalación
    });

    window.addEventListener('appinstalled', () => {
      this.installPromptVisible.next(false); // Oculta el botón cuando está instalado
    });
  }

  installPwa(): void {
    if (this.deferredPrompt) {
      this.isLoading.next(true); // Activa el estado de carga

      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('PWA instalada');
        }
        this.deferredPrompt = null;
        this.isLoading.next(false); // Desactiva el estado de carga
        this.installPromptVisible.next(false); // Oculta el botón después de la elección
      });
    }
  }
}
